export default __webpack_public_path__ + "static/media/nielsen-iq-brandbank-logo-white.5b95ad30.png";